import { useEffect } from "react";
import { useDispatch } from "react-redux";
import AppRouter from "./AppRouter";
// Archivo with its weight and width axes (amounts use the expanded width)
import "@fontsource-variable/archivo/wdth.css";
import { global } from "./services/GlobalController";
import { getStoredSession, restoreWalletSession } from "./helpers/session";
import { useWalletSession } from "./hooks/useWallet";

// reducers
import { setHeadInfo } from "./redux/actions/blockchain";
import { disconnectWallet, setConnected, setWallet, setWalletName } from "./redux/actions/wallet";

const App = () => {
  const dispatch = useDispatch();
  const { setSession } = useWalletSession();

  // head info (used by the farm status filters)
  useEffect(() => {
    const loadHead = async () => {
      try {
        let head = await global.getBlockHead();
        dispatch(setHeadInfo(head));
      } catch (error) {
        console.log(error);
      }
    };
    loadHead();
  }, []);

  // restore the wallet saved by the last connection
  useEffect(() => {
    const session = getStoredSession();
    if (!session) return;
    let cancelled = false;
    restoreWalletSession(session)
      .then(({ provider, signer, instance }) => {
        if (cancelled) return;
        setSession({ provider, signer, instance });
        dispatch(setWalletName(session.walletName));
        dispatch(setWallet(session.wallet));
        dispatch(setConnected(true));
      })
      .catch((error) => {
        console.log(error);
        if (!cancelled) dispatch(disconnectWallet());
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <AppRouter />;
};

export default App;
